export default "__VITE_ASSET__DyFG7Gj9__"